import React from "react";
import AjudaModal from "./AjudaModal";

function AjudaOfertes({ tipus, onTancar }) {
  const origen = tipus === "pressupost" ? "pressupost" : "treball";
  return (
    <AjudaModal
      id="ofertes-ajuda-title"
      titol="Com funcionen les Ofertes"
      lead={`Les ofertes d'un ${origen} recullen el que proposa un proveïdor: capçalera (data, referència, preu total) i, a sota, els productes. La mateixa pantalla serveix a Treballs i a Pressupostos.`}
      onTancar={onTancar}
    >
      <section className="dv2-help-section">
        <h4>Taula d'ofertes</h4>
        <ul>
          <li>
            Clic al títol d'una columna per ordenar. Un altre clic inverteix l'ordre. Per defecte, data més recent
            primer.
          </li>
          <li>
            El <strong>▶</strong> obre els productes d'aquella oferta. No cal seleccionar la fila abans: cada nivell té
            el seu <strong>…</strong>.
          </li>
          <li>
            Doble clic a l'oferta per consultar-la. <strong>Nova oferta</strong> és a la capçalera. En crear-ne una,
            queda expandida per poder-hi posar productes de seguida.
          </li>
        </ul>
      </section>

      <section className="dv2-help-section">
        <h4>Productes de l'oferta</h4>
        <ul>
          <li>
            <strong>Nou producte</strong> és a la capçalera de la subtaula (vermellosa). Allà tries el producte de
            catàleg, la quantitat i el preu unitari.
          </li>
          <li>Les columnes de la subtaula també s'ordenen. El preu total de l'oferta es recalcula amb els productes.</li>
          <li>Esborrar un producte no esborra l'oferta. Esborrar l'oferta sí que n'elimina els productes.</li>
        </ul>
      </section>

      <section className="dv2-help-section">
        <h4>Consultar</h4>
        <p>
          A la fitxa, les fletxes recorren la llista (ofertes o productes) en l'ordre de la taula. De la primera vas a
          l'última i a l'inrevés.
        </p>
      </section>
    </AjudaModal>
  );
}

export default AjudaOfertes;
